import React, { useEffect, useState } from "react";
import { Users, UserCheck, BadgeCheck, CalendarDays, CheckCircle2, ListChecks, UserPlus, Disc3, Wallet } from "lucide-react";
import { StatCard, PageHeader, Loader } from "@/components/shared";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { fmtPKR } from "@/lib/format";

export default function AdminDashboard() {
  const { t } = useI18n();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d) return <Loader />;

  return (
    <div>
      <PageHeader title={t("admin_dashboard")} subtitle="Command center overview." />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        <StatCard icon={Users} label={t("total_members")} value={d.total_members} accent="orange" testid="admin-stat-members" />
        <StatCard icon={UserCheck} label={t("active_members")} value={d.active_members} accent="green" />
        <StatCard icon={BadgeCheck} label={t("pending_kyc")} value={d.pending_kyc} accent="gold" testid="admin-stat-kyc" />
        <StatCard icon={CalendarDays} label={t("active_events")} value={d.active_events} accent="blue" />
        <StatCard icon={CheckCircle2} label={t("completed_events")} value={d.completed_events} accent="green" />
        <StatCard icon={ListChecks} label={t("predictions")} value={d.predictions} accent="purple" testid="admin-stat-predictions" />
        <StatCard icon={UserPlus} label={t("referrals")} value={d.referrals} accent="blue" />
        <StatCard icon={Disc3} label={t("spin_activity")} value={d.spin_activity} accent="orange" />
      </div>
      <div className="mt-6 max-w-sm">
        <StatCard icon={Wallet} label={t("total_balance")} value={fmtPKR(d.total_balance)} accent="gold" testid="admin-stat-balance" />
      </div>
    </div>
  );
}
